import clsx from 'clsx';
import React, { CSSProperties } from 'react';

import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';

import StepMarker, { StepMarkerStatus } from './StepMarker';

export interface StepsNavigationProps {
  className?: string;
  currentStep?: number;
  totalSteps: number;
  onBack?: () => void;
  onNext?: () => void;
  onSubmit?: () => void;
  stepStatuses: StepMarkerStatus[];
  style?: CSSProperties;
  valid?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    boxShadow: '0px 4px 44px rgba(6, 6, 6, 0.25)',
    borderRadius: 40,
    height: 90,
    padding: '0 30px',
  },
  button: {
    borderRadius: 100,
    height: 50,
    width: 160,
    color: '#fff',
  },
  backButton: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',

    '&:hover': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
  },
  nextButton: {
    '&:disabled': {
      backgroundColor: theme.palette.secondary.main,
      color: '#8D8D8D',
    },
  },
}));

const StepsNavigationDesktop = (props: StepsNavigationProps) => {
  const classes = useStyles(props);

  const {
    currentStep,
    totalSteps,
    className,
    style,
    valid,
    onBack,
    stepStatuses,
    onSubmit,
    onNext,
  } = props;

  const isSubmit = currentStep === totalSteps;

  return (
    <Box
      component="nav"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      className={clsx(classes.root, className)}
      style={style}
    >
      <Button
        disabled={currentStep === 1}
        disableElevation
        variant="contained"
        className={clsx(classes.button, classes.backButton)}
        onClick={onBack}
        startIcon={<ChevronLeft />}
      >
        Back
      </Button>
      <Box position="relative" flex={1} style={{ margin: '0 40px' }}>
        <Box
          position="absolute"
          top={0}
          bottom={0}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          {stepStatuses.map((status, index) => (
            <StepMarker key={index} status={status} />
          ))}
        </Box>
        <Box display="flex" alignItems="center" flex={1}>
          {stepStatuses.map((status, index) => {
            if (index > 0) {
              return (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    backgroundColor:
                      status === 'inactive' ? '#ffb781' : '#ffffff',
                    height: 2,
                    flex: 1,
                    marginRight: index + 1 === totalSteps ? 10 : 0,
                  }}
                />
              );
            }
            return null;
          })}
        </Box>
      </Box>
      <Button
        disabled={!valid}
        disableElevation
        variant="contained"
        color="secondary"
        className={clsx(classes.button, classes.nextButton)}
        onClick={isSubmit ? onSubmit : onNext}
        endIcon={<ChevronRight />}
      >
        {isSubmit ? 'Submit' : 'Next'}
      </Button>
    </Box>
  );
};

export default StepsNavigationDesktop;
